import Nullstack from 'nullstack';
export default function IconGenderHermaphrodite({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-gender-hermaphrodite",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 14v7"
  }), "   ", Nullstack.element("path", {
    d: "M9 18h6"
  }), "   ", Nullstack.element("path", {
    d: "M12 6a4 4 0 1 1 0 8a4 4 0 0 1 0 -8z"
  }), "   ", Nullstack.element("path", {
    d: "M15 3a3 3 0 1 1 -6 0"
  }), " ");
}